import React from 'react';

export const TaxIDIcon = () => (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.5 0C0.947715 0 0.5 0.447715 0.5 1L0.5 16.5C0.5 18.4333 2.06672 20 4 20L18 20C19.9333 20 21.5 18.4333 21.5 16.5L21.5 15C21.5 14.4477 21.0523 14 20.5 14L6.50002 14C5.94773 14 5.50002 14.4477 5.50002 15L5.50002 16.5C5.50002 16.9856 5.32725 17.2677 5.12159 17.4637C4.90108 17.6738 4.60402 17.8164 4.32436 17.9056C4.19016 17.9484 4.07379 17.9745 3.99418 17.9895C3.97342 17.9934 3.95546 17.9965 3.94068 17.9988C3.13948 17.9677 2.5 17.3088 2.5 16.5L2.5 2L16.5 2L16.5 11C16.5 11.5523 16.9477 12 17.5 12C18.0523 12 18.5 11.5523 18.5 11L18.5 1C18.5 0.447715 18.0523 0 17.5 0L1.5 0ZM18 18L7.17031 18C7.3757 17.5775 7.50002 17.0789 7.50002 16.5L7.50002 16L19.5 16L19.5 16.5C19.5 17.3287 18.8287 18 18 18Z"
            fill="inherit"
        />
        <path
            d="M5.5 6C5.5 5.44772 5.94772 5 6.5 5L12.5 5C13.0523 5 13.5 5.44772 13.5 6C13.5 6.55228 13.0523 7 12.5 7L6.5 7C5.94772 7 5.5 6.55228 5.5 6Z"
            fill="inherit"
        />
        <path
            d="M6.5 9C5.94772 9 5.5 9.44771 5.5 10C5.5 10.5523 5.94772 11 6.5 11H12.5C13.0523 11 13.5 10.5523 13.5 10C13.5 9.44771 13.0523 9 12.5 9H6.5Z"
            fill="inherit"
        />
    </svg>
);
